import {useLingui} from '@lingui/react'
import {LocalizationProvider, MobileDatePicker} from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import {useController} from 'react-hook-form'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'

/*eslint-disable*/
function DateInput({ control, name, autoFocus = null,disabled, label,required = true }) {
    const { _ } = useLingui()
    const {
        field,
        fieldState: { invalid, isTouched, isDirty },
        formState: { touchedFields, dirtyFields },
    } = useController({
        name,
        control,
        rules: { required: required },
    })

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
                label={label}
                disableFuture
                disabled={disabled}
                sx={{ width: '100%', marginTop: 1 }}
                mt={100}
                readOnly={false}
                value={field.value ? dayjs(field.value) : null}
                onAccept={date => {
                    field.onChange(date)
                }}
            />
        </LocalizationProvider>
    )
}

export default DateInput;